import { render, staticRenderFns } from "./InsertSvNummer.vue?vue&type=template&id=71ccf5e5"
import script from "./InsertSvNummer.vue?vue&type=script&lang=js"
export * from "./InsertSvNummer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports